import { useState, useEffect } from "react";
import { MdAdd, MdDelete } from "react-icons/md";
import { fetchOrganizerEvents } from "api/events.api";
import { InputField, SelectField } from ".././FormFields";
import CustomButton from "components/CustomButton";

export default function FloorMapForm({ initialData, onSubmit, onClose }) {
  const [mapName, setMapName] = useState("");
  const [eventId, setEventId] = useState("");
  const [floors, setFloors] = useState([
    { floor_id: "G", floor_label: "Ground Floor" },
  ]);
  const [submitting, setSubmitting] = useState(false);
  const [events, setEvents] = useState([]);
  const [errors, setErrors] = useState({ mapName: "" });

  // Load events for the current company
  useEffect(() => {
    const companyId = localStorage.getItem("company_id");
    if (!companyId) return;
    fetchOrganizerEvents(companyId)
      .then((res) => setEvents(res.data?.data || []))
      .catch(() => setEvents([]));
  }, []);

  // Populate form when editing
  useEffect(() => {
    if (!initialData) return;
    setMapName(initialData.map_name || "");
    setEventId(initialData.event_id?._id || initialData.event_id || "");
    setFloors(
      initialData.floors?.length
        ? initialData.floors.map(({ floor_id, floor_label }) => ({
            floor_id,
            floor_label,
          }))
        : [{ floor_id: "G", floor_label: "Ground Floor" }]
    );
  }, [initialData]);

  const addFloor = () =>
    setFloors((p) => [
      ...p,
      { floor_id: String(p.length), floor_label: `Floor ${p.length}` },
    ]);

  const removeFloor = (idx) => {
    if (floors.length === 1) return;
    setFloors((p) => p.filter((_, i) => i !== idx));
  };

  const updateFloor = (idx, field, value) =>
    setFloors((p) =>
      p.map((f, i) => (i === idx ? { ...f, [field]: value } : f))
    );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mapName.trim()) {
      setErrors((p) => ({
        ...p,
        mapName: "Please enter map name",
      }));
      return;
    }
    setSubmitting(true);
    try {
      await onSubmit({
        map_name: mapName.trim(),
        event_id: eventId || null,
        floors,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4 p-2">
      {/* <h2 className="text-lg font-semibold text-gray-800">
        {initialData ? "Edit Floor Map" : "Create Floor Map"}
      </h2> */}

      {/* Map Name */}
      <div>
        <InputField
          label="Map Name"
          name="mapName"
          value={mapName}
          onChange={(e) => setMapName(e.target.value)}
          placeholder="e.g. Exhibition Hall A"
          error={errors.mapName}
          required
        />

        {/* <label className="mb-1 block text-sm font-medium text-gray-700">
          Map Name <span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={mapName}
          onChange={(e) => setMapName(e.target.value)}
          placeholder="e.g. Exhibition Hall A"
          required
        /> */}
      </div>

      {/* Event */}
      <div>
        <SelectField
          label="Event"
          name="eventId"
          value={eventId}
          onChange={(e) => setEventId(e.target.value)}
          options={events.map((ev) => ({
            label: ev.event_name,
            value: ev._id,
          }))}
          placeholder="Search event..."
          isSearchable={true}
          // error={errors.exhibitor_category}
        />
        {/* <label className="mb-1 block text-sm font-medium text-gray-700">
          Event
        </label>
        <select
          className="w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={eventId}
          onChange={(e) => setEventId(e.target.value)}
        >
          <option value="">— Not linked to an event —</option>
          {events.map((ev) => (
            <option key={ev._id} value={ev._id}>
              {ev.event_name}
            </option>
          ))}
        </select> */}
        <p className="mt-1 text-xs text-gray-400">
          Optionally link this floor map to a specific event.
        </p>
      </div>

      {/* Floors */}
      <div>
        <div className="mb-2 flex items-center justify-between">
          <label className="form-label">Floors</label>
          {/* <button
            type="button"
            onClick={addFloor}
            className="flex items-center gap-1 rounded bg-blue-50 px-2 py-1 text-xs text-blue-600 hover:bg-blue-100"
          >
            <MdAdd size={14} /> Add Floor
          </button> */}
          <CustomButton
            label={"Add Floor"}
            icon={MdAdd}
            iconPos="left"
            variant="outline"
            color="#1A1A1A"
            borderColor="#02a9e0"
            onClick={addFloor}
            type ="button"
          />
        </div>
        <div className="flex flex-col gap-2">
          {floors.map((floor, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <div className="w-20">
                <InputField
                  value={floor.floor_id}
                  onChange={(e) => updateFloor(idx, "floor_id", e.target.value)}
                  placeholder="ID"
                  title="Floor ID (e.g. G, 1, 2)"
                />
              </div>

              {/* <input
                className="w-20 rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={floor.floor_id}
                onChange={(e) => updateFloor(idx, "floor_id", e.target.value)}
                placeholder="ID"
                title="Floor ID (e.g. G, 1, 2)"
              /> */}
              <div className="flex-1">
                <InputField
                  value={floor.floor_label}
                  onChange={(e) =>
                    updateFloor(idx, "floor_label", e.target.value)
                  }
                  placeholder="Label (e.g. Ground Floor)"
                />
              </div>
              {/* <input
                className="flex-1 rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={floor.floor_label}
                onChange={(e) =>
                  updateFloor(idx, "floor_label", e.target.value)
                }
                placeholder="Label (e.g. Ground Floor)"
              /> */}

              <button
                type="button"
                onClick={() => removeFloor(idx)}
                disabled={floors.length === 1}
                className="rounded p-1 text-red-500 hover:bg-red-50 disabled:opacity-30"
              >
                <MdDelete size={16} />
              </button>
            </div>
          ))}
        </div>
        <p className="mt-1 text-xs text-gray-400">
          Floor ID is used internally (e.g. G, 1, 2). Label is displayed in the
          app.
        </p>
      </div>

      <div className="flex justify-end gap-2 pt-2">
        <CustomButton
          label={"Cancel"}
          variant="outline"
          className="back-button"
          onClick={onClose}
        />
        {/* <button
          type="button"
          onClick={onClose}
          className="rounded border border-gray-300 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50"
        >
          Cancel
        </button> */}
        <CustomButton
          label={submitting ? "Saving..." : initialData ? "Update" : "Create"}
          disabled={submitting}
          variant="solid"
          className="submit-button"
          onClick={handleSubmit}
          type="submit"
        />
        {/* 
        <button
          type="submit"
          disabled={submitting}
          className="rounded bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700 disabled:opacity-60"
        >
          {submitting ? "Saving..." : initialData ? "Update" : "Create"}
        </button> */}
      </div>
    </form>
  );
}
